document.querySelectorAll('.mormaii-feature-cards__carousel').forEach((carousel) => {
  const section = carousel.closest('.mormaii-section') || carousel.parentElement;
  const grid = carousel.querySelector('.mormaii-feature-cards__grid');
  const prevBtn = section ? section.querySelector('[data-mormaii-carousel-prev]') : null;
  const nextBtn = section ? section.querySelector('[data-mormaii-carousel-next]') : null;
  const nav = carousel.querySelector('.mormaii-feature-cards__nav');
  const navHome = nav ? { parent: nav.parentNode, next: nav.nextSibling } : null;

  const cards = Array.from(carousel.querySelectorAll('[data-mormaii-feature-card]'));
  const cardHomes = new Map();
  cards.forEach((card) => cardHomes.set(card, { parent: card.parentNode, next: card.nextSibling }));

  let expandedCard = null;
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const desktopHoverQuery = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

  const scrollToCard = (direction) => {
    if (!grid || !cards.length) return;

    const current = grid.scrollLeft;
    const tolerance = 4;
    let target;

    if (direction > 0) {
      target = cards.find((card) => card.offsetLeft > current + tolerance);
      if (!target) target = cards[cards.length - 1];
    } else {
      target = cards
        .slice()
        .reverse()
        .find((card) => card.offsetLeft < current - tolerance);
      if (!target) target = cards[0];
    }

    grid.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
  };

  const setCardState = (card, expand) => {
    const toggle = card.querySelector('[data-mormaii-card-toggle]');
    const details = card.querySelector('.mormaii-feature-card__details');
    card.classList.toggle('is-expanded', expand);
    if (toggle) toggle.setAttribute('aria-expanded', String(expand));
    if (details) details.setAttribute('aria-hidden', String(!expand));
  };

  const collapseCard = (card) => {
    setCardState(card, false);

    if (mobileQuery.matches) {
      document.body.classList.remove('mormaii-scroll-lock');
      const details = card.querySelector('.mormaii-feature-card__details');
      const cta = card.querySelector('.mormaii-feature-card__cta');

      if (nav && navHome && nav.closest('.mormaii-feature-card') === card) {
        navHome.parent.insertBefore(nav, navHome.next);
      }
      if (details && cta) details.appendChild(cta);

      const home = cardHomes.get(card);
      if (home) home.parent.insertBefore(card, home.next);
    }

    if (expandedCard === card) expandedCard = null;
  };

  const expandCard = (card) => {
    setCardState(card, true);

    const isMobile = mobileQuery.matches;
    document.body.classList.toggle('mormaii-scroll-lock', isMobile);

    if (isMobile) {
      // Move the card once, before painting the expanded state, to avoid
      // animating through the carousel's layout on smaller devices.
      document.body.appendChild(card);
      const cta = card.querySelector('.mormaii-feature-card__cta');
      if (cta) {
        card.appendChild(cta);
        if (nav) cta.appendChild(nav);
      }
    } else if (grid) {
      card.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }

    expandedCard = card;
  };

  const switchExpandedCard = (direction) => {
    if (!expandedCard) return false;

    const currentIndex = cards.indexOf(expandedCard);
    if (currentIndex === -1) return false;

    let nextIndex = currentIndex + direction;
    if (nextIndex < 0) nextIndex = cards.length - 1;
    if (nextIndex >= cards.length) nextIndex = 0;

    const nextCard = cards[nextIndex];
    if (nextCard === expandedCard) return true;

    collapseCard(expandedCard);
    window.requestAnimationFrame(() => expandCard(nextCard));
    return true;
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (switchExpandedCard(-1)) return;
      scrollToCard(-1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (switchExpandedCard(1)) return;
      scrollToCard(1);
    });
  }

  cards.forEach((card) => {
    const toggle = card.querySelector('[data-mormaii-card-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const willExpand = expandedCard !== card;

      if (expandedCard && expandedCard !== card) {
        collapseCard(expandedCard);
      }

      if (willExpand) {
        expandCard(card);
      } else {
        collapseCard(card);
      }
    });

    card.addEventListener('mouseenter', () => {
      if (!desktopHoverQuery.matches || expandedCard === card) return;

      if (expandedCard) collapseCard(expandedCard);
      expandCard(card);
    });

    card.addEventListener('mouseleave', () => {
      if (!desktopHoverQuery.matches || expandedCard !== card) return;
      collapseCard(card);
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let touchTracking = false;

    card.addEventListener(
      'touchstart',
      (event) => {
        if (!mobileQuery.matches || expandedCard !== card || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchTracking = true;
      },
      { passive: true }
    );

    card.addEventListener(
      'touchend',
      (event) => {
        if (!touchTracking) return;
        touchTracking = false;
        if (expandedCard !== card) return;

        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        const threshold = 50;

        if (Math.abs(deltaX) > threshold && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
          switchExpandedCard(deltaX < 0 ? 1 : -1);
        }
      },
      { passive: true }
    );
  });
});
